<template>
  <section class="hm-sec-outer">
        <h2 v-if="section.title" class="hm-sec-ttl">{{section.title}}</h2>
        <div class="content-box hm-sec-inner">
            <div class="hm-sec-left" :class="section.left ? 'order-2' : 'order-1'">
                <slot name="left"/>
                <div v-if="section.left" class="txt-wrp">
                    <h3 class="hm-h3">{{section.subTitle}}</h3>
                    <h4 class="hm-h4">{{section.text}}</h4>
                </div>
            </div>
            <div class="hm-sec-right" :class="section.right ? 'order-2' : 'order-1'">
                <slot name="right"/>
                <div v-if="section.right" class="txt-wrp">
                    <h3 class="hm-h3">{{section.subTitle}}</h3>
                    <h4 class="hm-h4">{{section.text}}</h4>
                </div>
            </div>
        </div>
  </section>
</template>

<script>
export default {
    props:{
        section:Object,
        default:()=>{}
    }
}
</script>

<style scoped>
.hm-sec-outer{
    background: white;
    padding: 38px;
    overflow: hidden;
}

.hm-sec-inner{
    display: flex;
    justify-content: space-between;
    padding: 0 !important;
    align-items: center;
}

.hm-sec-inner  > *{
    width: 50%;
}

.hm-sec-right,
.hm-sec-left{
    display: flex;
}

.hm-sec-right{
    justify-content: flex-end;
}

.hm-sec-left{
    justify-content: flex-start;
}

/* .align-center{
    align-self: center;
} */

@media screen and (max-width: 1366px){
    .hm-sec-outer{
        padding: 31px;
    }
}

@media screen and (max-width: 800px){
    .hm-sec-inner{
        display: flex;
        flex-direction: column;
    }

    .hm-sec-inner  > *{
        width: 100%;
    }

    .hm-sec-right,
    .hm-sec-left{
        justify-content: center;
    }

    .order-1{
        order: 1;
    }

    .order-2{
        order: 2;
    }
}

@media screen and (max-width: 589px){
    .hm-sec-outer{
        padding: 20px;
    }
}
</style>